import { IonIcon, IonListHeader } from '@ionic/react';
import RunFavoriteCard from 'components/listElements/RunFavoriteCard/RunFavoriteCard';
import { RunModel } from 'models/RunModel/RunModel';
import { Trans } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';

interface FavoritesCarouselProps {
  favorites: Array<RunModel>;
  onClick?: (item: RunModel) => void;
}

const FavoritesCarousel: React.FunctionComponent<FavoritesCarouselProps> = (
  props
) => {
  if (props.favorites.length === 0) {
    return null;
  }
  return (
    <div
      id="favorites"
      className="section-container"
      style={{ marginTop: '16px' }}
    >
      <IonListHeader className="section-header">
        <IonIcon
          src={`/assets/icons/star_filled.svg`}
          style={{ width: '0.85em', marginLeft: '8px' }}
        />
        <Trans i18nKey="FRIENDS_FAVORITES">Favoriten</Trans>
        <span className="section-count" style={{ color: 'var(--ion-color-primary)' }}>({props.favorites.length})</span>
      </IonListHeader>
      <Swiper
        slidesPerView="auto"
        spaceBetween={8}
        slidesOffsetAfter={4}
        slidesOffsetBefore={4}
        className="animated animate__animated animate__fadeInLeft animate__faster"
      >
        {props.favorites.map((item, index) => (
          <SwiperSlide key={`favorite_${item.id}_${index}`}>
            <RunFavoriteCard 
              item={item} 
              isFriend={true}
              onClick={props.onClick}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default FavoritesCarousel;
